import type { AtRiskFlagStatus, AtRiskSignalType, LocationAtRiskFlag } from '@/types/customer-ops';

/** Computed at-risk types that duplicate review-due, Insights commercial, or Upcoming Launches surfaces. */
export const DUPLICATE_AT_RISK_SIGNAL_TYPES: ReadonlySet<AtRiskSignalType> = new Set([
  'overdue_review',
  'commercial_gap',
  'gates_stalled',
]);

/** Action-now at-risk rows for nav badges and hub counts (excludes monitoring/watch-band). */
export function isActionableAtRiskFlag(status: AtRiskFlagStatus): boolean {
  return status === 'open';
}

export function isPriorityAtRiskFeedSignal(signalType: AtRiskSignalType): boolean {
  return !DUPLICATE_AT_RISK_SIGNAL_TYPES.has(signalType);
}

export function countActionableAtRiskFlags(flags: readonly LocationAtRiskFlag[]): number {
  return flags.filter((row) => isActionableAtRiskFlag(row.status)).length;
}

export function atRiskStatusBadgeVariant(
  status: AtRiskFlagStatus
): 'default' | 'secondary' | 'outline' | 'destructive' {
  switch (status) {
    case 'resolved':
      return 'secondary';
    case 'monitoring':
      return 'default';
    default:
      return 'outline';
  }
}
